import axios from 'axios';
import { useQuery } from 'react-query';
import {
    apiGatewayUrl,
    AtoZClientId,
    getApiGatewayHeaders,
    getCurrentStage
} from '../../client';
import { FetchTranscriptsRequest, FetchTranscriptsResponse } from '../../types';

/**
 * Hook to fetch the number of required trainings for the user in LearnHub
 * @param isEnabled - flag to enables hook
 * @returns required training count
 * @remarks
 * On an API error this will return a cached value(if available) or undefined
 */
const useRequiredTrainingCount = (isEnabled: boolean) => {
    const currentStage = getCurrentStage();
    const headers = getApiGatewayHeaders(currentStage, AtoZClientId.LEARN_HUB);

    const requestPayload: FetchTranscriptsRequest = {
        fetchTranscriptsCriteria: {
            transcriptStatusCriteria: {
                transcriptStatuses: ['REGISTERED', 'IN_PROGRESS']
            }
        },
        transcriptOptionalAttributesList: ['REQUIRED']
    };

    /**
     * @remarks
     * Try catch is not required as errors are handled by react-query
     */
    async function fetchTranscripts() {
        const response = await axios.post<FetchTranscriptsResponse>(
            `${apiGatewayUrl}/fetchTranscripts`,
            requestPayload,
            { headers }
        );
        return response.data.transcripts.filter(
            (transcript) =>
                transcript.transcriptOptionalDetailsMap.REQUIRED === 'true'
        ).length;
    }

    const { data: requiredCount } = useQuery(
        'learnHub_RequiredTranscripts',
        fetchTranscripts,
        {
            staleTime: 1 * 60 * 1000,
            cacheTime: 6 * 60 * 1000,
            enabled: isEnabled
        }
    );

    return requiredCount;
};

export { useRequiredTrainingCount };
